import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Items from './components/items/Items';
import Login from './components/Login';
import Approval from './components/items/Approval';
import ItemsAssign from './components/items/ItemsAssign';
import UploadExcel from './components/items/UploadExcel';
import './app.css';

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    // Check if the user is logged in
    const userLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
    setIsLoggedIn(userLoggedIn);
  }, []);

  const handleLogin = () => {
    setIsLoggedIn(true);
    localStorage.setItem('isLoggedIn', 'true');
  };

  const handleLogout = () => {
    setIsLoggedIn(false);
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('currentPath'); // Clear the last visited path
  };

  const PersistedRoutes = () => {
    const location = useLocation();
    useEffect(() => {
      // Save the current path to localStorage
      localStorage.setItem('currentPath', location.pathname);
    }, [location]);

    const currentPath = localStorage.getItem('currentPath') || '/items'; // Default to /items

    return (
      <Routes>
        <Route path="/login" element={isLoggedIn ? <Navigate to={currentPath} /> : <Login onLogin={handleLogin} />} />
        <Route path="/items" element={isLoggedIn ? <Items /> : <Navigate to="/login" />} />
        <Route path="/approval" element={isLoggedIn ? <Approval /> : <Navigate to="/login" />} />
        <Route path="/items-assign/:customerId" element={isLoggedIn ? <ItemsAssign /> : <Navigate to="/login" />} />
        <Route path="/uploadexcel/:type" element={isLoggedIn ? <UploadExcel /> : <Navigate to="/login" />} />
        <Route path="*" element={<Navigate to={isLoggedIn ? '/items' : '/login'} />} /> 
      </Routes>
    );
  };

  return (
    <Router>
      <div>
        <Header isLoggedIn={isLoggedIn} onLogout={handleLogout} />
        <div className="main-content">
          <PersistedRoutes />
        </div>
      </div>
    </Router>
  );
}

export default App;
